/* Product Swiper (mt-collectie-swipe) — script. Geladen met defer vanuit snippets/mt-collectie-swipe.liquid */
(function () {
  var root = document.getElementById('mt-cswipe');
  if (!root || root.dataset.mtsInit) return;
  root.dataset.mtsInit = '1';

  var MAX = parseInt(root.dataset.max, 10) || 60;
  var euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  /* ---------- Banner boven het productgrid plaatsen ---------- */
  var banner = root.querySelector('[data-mts-banner]');
  var anchor = document.getElementById('ProductGridContainer');
  if (anchor && banner) {
    banner.classList.add('mts-banner--moved');
    anchor.parentNode.insertBefore(banner, anchor);
    banner.hidden = false;
  } else if (banner) {
    banner.hidden = false;
  }

  /* ---------- Per-collectie state ----------
     Opslagformaat mts_col_{handle}:
     { title, decisions: [{h, liked, s?}] }
     s = snapshot van gelikete producten voor de verlanglijst:
     { t: titel, i: image, u: url, pr: prijs, ca: vanprijs,
       v: variantId, av: leverbaar, q: bestelstap }                           */
  var HANDLE = '', TITLE = '', STORAGE_KEY = '';
  var products = [], byHandle = {}, state = { decisions: [] }, loaded = false;
  var cache = {};

  function snapshot(p) {
    return { t: p.title, i: p.image, u: p.url, pr: p.priceNum, ca: p.compareAt, v: p.variantId, av: p.available, q: p.quantity || 1 };
  }

  function setCollection(handle, title) {
    HANDLE = handle;
    TITLE = title || handle;
    STORAGE_KEY = 'mts_col_' + HANDLE;
    state = { decisions: [] };
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && Array.isArray(saved.decisions)) state = saved;
    } catch (e) {}
    products = cache[HANDLE] || [];
    loaded = !!cache[HANDLE];
    byHandle = {};
    products.forEach(function (p) { byHandle[p.handle] = p; });
    root.querySelectorAll('[data-mts-colname]').forEach(function (el) { el.textContent = TITLE; });
  }

  function persist() {
    state.title = TITLE;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function likes() {
    return state.decisions.filter(function (d) { return d.liked; }).map(function (d) { return byHandle[d.h]; }).filter(Boolean);
  }
  function nopes() {
    return state.decisions.filter(function (d) { return !d.liked; }).map(function (d) { return byHandle[d.h]; }).filter(Boolean);
  }
  function idx() { return state.decisions.length; }

  /* ---------- Elementen ---------- */
  function $(sel) { return root.querySelector(sel); }
  var overlay = $('[data-mts-overlay]');
  var screens = {};
  root.querySelectorAll('[data-mts-screen]').forEach(function (el) { screens[el.dataset.mtsScreen] = el; });
  var deckEl = $('[data-mts-deck]');
  var progressEl = $('[data-mts-progress]');
  var undoBtn = $('[data-mts-undo]');
  var gridEl = $('[data-mts-grid]');
  var rejectedEl = $('[data-mts-rejected]');
  var rejectedWrap = $('[data-mts-rejected-wrap]');

  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function priceHtml(p) {
    if (p.compareAt && p.compareAt > p.priceNum) {
      return '<p class="mts-price mts-price--sale">' +
        '<span class="mts-price__was">' + euro.format(p.compareAt) + '</span>' +
        euro.format(p.priceNum) + '</p>';
    }
    return '<p class="mts-price">' + euro.format(p.priceNum) + '</p>';
  }
  function priceText(p) {
    if (p.compareAt && p.compareAt > p.priceNum) {
      return euro.format(p.priceNum) + ' (van ' + euro.format(p.compareAt) + ')';
    }
    return euro.format(p.priceNum);
  }

  /* ---------- Popup ---------- */
  /* MT: kiesmodus (alleen vanuit "Maak het compleet"): extra knop "Kies deze" die het product teruggeeft */
  var kiesDoel = null;
  function openPopup(handle, title) {
    if (!handle) return;
    setCollection(handle, title);
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (!loaded) { loadProducts(); } else { route(); }
  }
  function closePopup() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }
  /* MT: inline productlijst (serieblok op productpagina) i.p.v. collectie-fetch */
  var inline = {};
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mts-open]');
    if (!btn) return;
    var h = btn.dataset.mtsHandle || root.dataset.handle;
    var t = btn.dataset.mtsTitle || root.dataset.title;
    kiesDoel = btn.dataset.mtsKies || null;
    var kw = root.querySelector('[data-mts-kies-wrap]'); if (kw) kw.hidden = !kiesDoel;
    if (btn.dataset.mtsInline) {
      var el = document.getElementById(btn.dataset.mtsInline);
      try { inline[h] = JSON.parse(el.textContent); } catch (err) { inline[h] = null; }
    }
    openPopup(h, t);
  });
  $('[data-mts-close]').addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

  /* ---------- Producten laden ---------- */
  function loadProducts() {
    show('loading');
    var all = [];
    var forHandle = HANDLE;
    if (inline[forHandle]) { all = inline[forHandle]; finish(); return; }
    function page(n) {
      fetch('/collections/' + forHandle + '/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (data) {
          var items = (data && data.products) || [];
          all = all.concat(items);
          if (items.length === 250 && all.length < MAX) { page(n + 1); } else { finish(); }
        })
        .catch(function () { show('error'); });
    }
    function finish() {
      var list = all.slice(0, MAX).map(function (p) {
        var v = (p.variants && p.variants[0]) || {};
        var img = (p.images && p.images[0] && p.images[0].src) || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=720';
        var cmp = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        var perTwo = tags.some(function (tag) { return String(tag).trim() === 'Multifurn-per-2'; });
        return {
          handle: p.handle,
          title: p.title,
          priceNum: v.price ? parseFloat(v.price) : 0,
          compareAt: cmp,
          url: '/products/' + p.handle,
          image: img,
          variantId: v.id,
          available: !!v.available,
          quantity: perTwo ? 2 : 1
        };
      }).filter(function (p) { return p.image; });
      cache[forHandle] = list;
      if (forHandle !== HANDLE) return;
      products = list;
      byHandle = {};
      products.forEach(function (p) { byHandle[p.handle] = p; });
      state.decisions = state.decisions.filter(function (d) { return byHandle[d.h]; });
      loaded = true;
      route();
    }
    page(1);
  }

  /* ---------- Routing bij openen ---------- */
  function route() {
    if (!products.length) { show('error'); return; }
    var params = new URLSearchParams(location.search);
    if (params.get('likes') && !root.dataset.mtsUrlHandled) {
      root.dataset.mtsUrlHandled = '1';
      var fromUrl = params.get('likes').split(',').filter(function (h) { return byHandle[h]; });
      if (fromUrl.length) {
        state.decisions = fromUrl.map(function (h) { return { h: h, liked: true, s: snapshot(byHandle[h]) }; });
        persist();
        showResult();
        return;
      }
    }
    if (idx() > 0 && idx() < products.length) {
      $('[data-mts-resume-info]').textContent =
        'Je hebt al ' + idx() + ' van de ' + products.length + ' producten bekeken en ' + likes().length + ' favorieten.';
      show('resume');
    } else if (idx() >= products.length && state.decisions.length) {
      showResult();
    } else {
      startDeck();
    }
  }

  $('[data-mts-resume]').addEventListener('click', startDeck);
  $('[data-mts-viewresult]').addEventListener('click', showResult);
  $('[data-mts-restart-fresh]').addEventListener('click', restart);

  function restart() {
    state.decisions = [];
    persist();
    startDeck();
  }

  /* ---------- Deck ---------- */
  function startDeck() {
    show('deck');
    renderDeck();
  }

  function cardHtml(p) {
    return '' +
      '<div class="mts-card__img"><img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>' +
      '<div class="mts-card__info">' +
        '<div class="mts-card__meta">' +
          '<p class="mts-card__title">' + escapeHtml(p.title) + '</p>' +
          priceHtml(p) +
        '</div>' +
        '<a class="mts-card__view" href="' + p.url + '" target="_blank" rel="noopener">Bekijk →</a>' +
      '</div>' +
      '<span class="mts-stamp mts-stamp--like">♥ Bewaren</span>' +
      '<span class="mts-stamp mts-stamp--nope">✕ Overslaan</span>';
  }

  function renderDeck() {
    deckEl.innerHTML = '';
    var i = idx();
    if (i >= products.length) { showResult(); return; }
    var upcoming = products.slice(i, i + 3);
    upcoming.reverse().forEach(function (p, j) {
      var card = document.createElement('div');
      card.className = 'mts-card';
      var depth = upcoming.length - 1 - j;
      card.style.transform = 'translateY(' + (depth * 10) + 'px) scale(' + (1 - depth * 0.04) + ')';
      card.innerHTML = cardHtml(p);
      deckEl.appendChild(card);
    });
    var top = deckEl.lastElementChild;
    if (top) { top.classList.add('mts-card--top'); attachDrag(top); }
    $('[data-mts-counter]').textContent = i + 1;
    $('[data-mts-total]').textContent = products.length;
    $('[data-mts-likecount]').textContent = likes().length;
    progressEl.style.width = Math.round((i / products.length) * 100) + '%';
    undoBtn.disabled = i === 0;
  }

  /* ---------- Swipe-mechaniek ----------
     naar RECHTS slepen (dx > 0)  = BEWAREN
     naar LINKS slepen  (dx < 0)  = OVERSLAAN                */
  var animating = false;

  function attachDrag(card) {
    var startX = 0, dx = 0, dragging = false;
    var likeStamp = card.querySelector('.mts-stamp--like');
    var nopeStamp = card.querySelector('.mts-stamp--nope');

    card.addEventListener('pointerdown', function (e) {
      if (animating) return;
      if (e.target.closest('a, button')) return;
      dragging = true;
      startX = e.clientX;
      card.setPointerCapture(e.pointerId);
      card.style.transition = 'none';
    });
    card.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      card.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx * 0.06) + 'deg)';
      likeStamp.style.opacity = Math.min(Math.max(dx / 70, 0), 1);
      nopeStamp.style.opacity = Math.min(Math.max(-dx / 70, 0), 1);
      card.classList.toggle('mts-card--leaning-like', dx > 25);
      card.classList.toggle('mts-card--leaning-nope', dx < -25);
    });
    function release() {
      if (!dragging) return;
      dragging = false;
      if (dx > 90) { swipe(true, card); }
      else if (dx < -90) { swipe(false, card); }
      else {
        card.style.transition = 'transform .25s ease';
        card.style.transform = '';
        likeStamp.style.opacity = 0;
        nopeStamp.style.opacity = 0;
        card.classList.remove('mts-card--leaning-like', 'mts-card--leaning-nope');
      }
      dx = 0;
    }
    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);
  }

  function swipe(liked, cardEl) {
    if (animating) return;
    var card = cardEl || deckEl.querySelector('.mts-card--top');
    if (!card) return;
    animating = true;
    var p = products[idx()];
    if (p) {
      var entry = { h: p.handle, liked: liked };
      if (liked) entry.s = snapshot(p);
      state.decisions.push(entry);
    }
    persist();
    var dir = liked ? 1 : -1;
    var stamp = card.querySelector(liked ? '.mts-stamp--like' : '.mts-stamp--nope');
    if (stamp) stamp.style.opacity = 1;
    card.style.transition = 'transform .35s ease, opacity .35s ease';
    card.style.transform = 'translateX(' + (dir * 480) + 'px) rotate(' + (dir * 24) + 'deg)';
    card.style.opacity = '0';
    setTimeout(function () { animating = false; renderDeck(); }, 330);
  }

  function undo() {
    if (animating || !state.decisions.length) return;
    state.decisions.pop();
    persist();
    renderDeck();
  }

  function skipCurrent() {
    if (animating) return;
    var card = deckEl.querySelector('.mts-card--top');
    if (!card) return;
    var i = idx();
    var p = products[i];
    if (!p) return;
    animating = true;
    products.splice(i, 1);
    products.push(p);
    card.style.transition = 'transform .3s ease, opacity .3s ease';
    card.style.transform = 'translateY(-36px)';
    card.style.opacity = '0';
    setTimeout(function () { animating = false; renderDeck(); }, 280);
  }

  $('[data-mts-kies]').addEventListener('click', function () {
    var p = products[idx()]; if (!p || !kiesDoel) return;
    var v = (p.variants && p.variants[0]) || {};
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    document.dispatchEvent(new CustomEvent('mts:kies', { detail: { doel: kiesDoel, handle: p.handle, title: p.title, price: v.price, variant: v.id, image: img } }));
    kiesDoel = null; closePopup();
  });
  $('[data-mts-like]').addEventListener('click', function () { swipe(true); });
  $('[data-mts-nope]').addEventListener('click', function () { swipe(false); });
  $('[data-mts-next]').addEventListener('click', skipCurrent);
  undoBtn.addEventListener('click', undo);
  $('[data-mts-finish]').addEventListener('click', showResult);

  document.addEventListener('keydown', function (e) {
    if (overlay.hidden || screens.deck.hidden) return;
    if (e.key === 'ArrowRight') swipe(true);
    if (e.key === 'ArrowLeft') swipe(false);
    if (e.key === 'Backspace') { e.preventDefault(); undo(); }
  });

  /* ---------- Resultaat ---------- */
  function showResult() {
    show('result');
    var liked = likes();
    var rejected = nopes();
    var remaining = products.length - idx();

    $('[data-mts-result-title]').textContent = liked.length
      ? 'Jouw favorieten (' + liked.length + ')'
      : 'Nog geen favorieten';
    $('[data-mts-result-sub]').textContent = liked.length
      ? 'Bekijk je selectie of leg je favorieten direct in je winkelwagen.'
      : 'Swipe naar rechts of tik op het hart bij producten die je mooi vindt.';

    gridEl.innerHTML = '';
    liked.forEach(function (p) { gridEl.appendChild(itemEl(p, true)); });

    rejectedWrap.hidden = rejected.length === 0;
    $('[data-mts-rejected-count]').textContent = rejected.length;
    rejectedEl.innerHTML = '';
    rejected.forEach(function (p) { rejectedEl.appendChild(itemEl(p, false)); });

    var contBtn = $('[data-mts-continue]');
    contBtn.hidden = remaining <= 0;
    $('[data-mts-remaining]').textContent = remaining;

    var lines = liked.map(function (p) { return '• ' + p.title + ' — ' + priceText(p) + '\n  ' + location.origin + p.url; });
    var body = 'Mijn favorieten uit ' + TITLE + ' bij Mooier Thuis:\n\n' + lines.join('\n\n') + '\n\nBekijk mijn volledige lijst:\n' + shareUrl();
    $('[data-mts-mail]').href = 'mailto:?subject=' + encodeURIComponent('Mijn favorieten – ' + TITLE + ' | Mooier Thuis') + '&body=' + encodeURIComponent(body);
  }

  function itemEl(p, isLiked) {
    var item = document.createElement('div');
    item.className = 'mts-item';
    item.innerHTML =
      '<a class="mts-item__img" href="' + p.url + '" target="_blank" rel="noopener"><img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></a>' +
      '<div class="mts-item__body">' +
        '<a class="mts-item__title" href="' + p.url + '" target="_blank" rel="noopener">' + escapeHtml(p.title) + '</a>' +
        priceHtml(p) +
        '<a class="mts-item__view" href="' + p.url + '" target="_blank" rel="noopener">Bekijk productpagina →</a>' +
        (isLiked
          ? (p.available ? '<button type="button" class="mts-item__cart" data-variant="' + p.variantId + '" data-quantity="' + (p.quantity || 1) + '">In winkelwagen</button>' : '<p class="mts-price">Tijdelijk uitverkocht</p>') +
            '<button type="button" class="mts-item__remove" data-remove="' + p.handle + '">Verwijderen</button>'
          : '<button type="button" class="mts-item__relike" data-relike="' + p.handle + '">♥ Toch bewaren</button>'
        ) +
      '</div>';
    return item;
  }

  root.querySelector('.mts-shell').addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-variant]');
    if (cartBtn) {
      cartBtn.disabled = true;
      cartBtn.textContent = 'Toevoegen…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(cartBtn.dataset.variant, 10), quantity: parseInt(cartBtn.dataset.quantity, 10) || 1 })
      }).then(function (r) {
        cartBtn.textContent = r.ok ? '✓ Toegevoegd' : 'Mislukt, probeer opnieuw';
        if (!r.ok) cartBtn.disabled = false;
        if (r.ok) document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {
        cartBtn.textContent = 'Mislukt, probeer opnieuw';
        cartBtn.disabled = false;
      });
      return;
    }
    var removeBtn = e.target.closest('[data-remove]');
    if (removeBtn) {
      var h1 = removeBtn.dataset.remove;
      state.decisions = state.decisions.map(function (d) {
        return d.h === h1 ? { h: d.h, liked: false } : d;
      });
      persist();
      showResult();
      return;
    }
    var relikeBtn = e.target.closest('[data-relike]');
    if (relikeBtn) {
      var h2 = relikeBtn.dataset.relike;
      state.decisions = state.decisions.map(function (d) {
        if (d.h !== h2) return d;
        var entry = { h: d.h, liked: true };
        if (byHandle[h2]) entry.s = snapshot(byHandle[h2]);
        return entry;
      });
      persist();
      showResult();
    }
  });

  $('[data-mts-continue]').addEventListener('click', startDeck);
  $('[data-mts-restart]').addEventListener('click', restart);

  function shareUrl() {
    var url = new URL(location.origin + location.pathname);
    url.searchParams.set('c', HANDLE);
    url.searchParams.set('likes', likes().map(function (p) { return p.handle; }).join(','));
    return url.toString();
  }

  $('[data-mts-copy]').addEventListener('click', function () {
    var url = shareUrl();
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      var note = $('[data-mts-copy-note]');
      note.hidden = false;
      setTimeout(function () { note.hidden = true; }, 3500);
    }).catch(function () {
      prompt('Kopieer deze link:', url);
    });
  });

  var initParams = new URLSearchParams(location.search);
  if (initParams.get('likes')) {
    openPopup(initParams.get('c') || root.dataset.handle, root.dataset.title || initParams.get('c'));
  }
})();
